<template>
  <!-- <f7-page class="EditAccountMember"> -->
  <div class="page">
    <!--bottom-toolbar></bottom-toolbar-->
    <div class="page-content">
      <div class="layoutTop"/>

      <div class="container-fluid">
        <div class="row">
          <div class="col-md-10 offset-md-1 ">
            <back-button returnUrl="/accountMembers/"></back-button>
            <div class="panel21 panel-default">
              <form>
                <div class="form-group row">
                  <label class="col-5 col-sm-2 col-form-label">{{ $t('loginPage.lgn') }}</label>
                  <div class="col-7 col-sm-10 col-form-label">
                    <span>{{ login }}</span>
                  </div>
                </div>
                <div class="form-group row">
                  <label class="col-5 col-sm-2 col-form-label">{{ $t('rights.rights_profile') }}</label>
                  <div class="col-7 col-sm-10">
                    <select class="form-control" id="sel4" v-model="selectedConfig" readonly>
                      <option :value="{}">{{ $t('rights.select_profile') }}</option>
                      <option v-for="config in configList"
                        :key="config.idProfile"
                        :value="config">
                        {{ config.libelleProfile }}
                      </option>
                    </select>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="row justify-content-start">
          <div class="offset-md-5 col-md-3" @click="saveAccountMember">
            <a style="color: #000;">
              <button v-if="this.previousProfilId !== this.selectedConfig.idProfile"round class="button-action firstButtonMarginTop milkyBlockBlack">
                <f7-icon f7="save"></f7-icon>
                <span>{{ $t('common.sve') }}</span>
              </button>
            </a>
          </div>
          <div class="col-md-3">
            <button round
            class="button-action firstButtonMarginTop milkyBlockBlack"
            @click="removeAccountMember">
              <f7-icon f7="close_round_fill"></f7-icon>
              <span>{{ $t('common.rm_label') }}</span>
            </button>
          </div>
        </div>
      </div>

      <div class="toolbarPageBottomBlank"></div>
  <!-- </f7-page> -->
    </div>
  </div>
</template>

<script>
import backButton from '@/components/common/backButton.vue'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import { loadPage, pageBack } from '@/helpers/routing'

export default {
  name: 'AccountMemberDetail',
  components: {
    'back-button': backButton,
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      login: '',
      status: '',
      configList: [],
      selectedConfig: {},
      previousProfilId: -1
    }
  },
  created () {
    this.login = this.$settings.currentAccountMember.login
    let that = this
    that.$engine.rights.getAllProfiles().then(resp => {
      that.configList = resp.profiles
      let usedConfig = that.configList.find(config => {
        if (config.users) {
          return config.users.find(user => {
            return user === that.login
          })
        }
      })
      if (usedConfig) {
        that.previousProfilId = usedConfig.idProfile
        that.selectedConfig = usedConfig
      }
    })
  },
  methods: {
    removeAccountMember () {
      let that = this
      that.$f7.modal({
        title: that.$t('businessMembers.account_member_deletion_confirmation'),
        buttons: [
          {
            text: that.$t('common.accpt'),
            onClick: function () {
              that.$engine.accounts
              .deleteUserFromAccount(that.$settings.currentAccountMember.id)
              .then(resp => {
                that.$f7.modal({
                  title: 'Account deleted',
                  text: '<span class="preloader"></span>'
                })
                setTimeout(function () {
                  that.login = ''
                  that.$f7.closeModal()
                  // that.$bus.$emit('refresh-cache-account-members')
                  loadPage(that, {url: '/accountMembers/', force: false, ignoreCache: false})
                }, 2000)
              })
              .catch(err => {
                this.handleError(err) // mixins errorHandlerMixins
              })
            }
          },
          {
            text: this.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    saveAccountMember () {
      let that = this
      that.$f7.modal({
        title: that.$t('businessMembers.mdfy_usr'),
        buttons: [
          {
            text: that.$t('common.accpt'),
            onClick: function () {
              // check if profile changed
              if (that.selectedConfig.idProfile === -1 || that.previousProfilId === that.selectedConfig.idProfile) {
                return
              }
              // erase user from previous profile
              if (that.previousProfilId !== -1) {
                let oldConfig = that.configList.find(config => {
                  return that.previousProfilId === config.idProfile
                })
                oldConfig.users = oldConfig.users.filter(user => user !== that.login)
                that.$engine.rights.editProfile(oldConfig.idProfile, oldConfig.libelleProfile, oldConfig.users, [], [])
              }
              // add user to new profile
              if (Object.keys(that.selectedConfig).length) {
                if (!that.selectedConfig.users) {
                  that.selectedConfig.users = []
                }
                that.selectedConfig.users.push(that.login)
                that.$engine.rights.editProfile(that.selectedConfig.idProfile, that.selectedConfig.libelleProfile, that.selectedConfig.users, [], [])
                that.$f7.alert('', that.$t('common.modif_saved'))
                pageBack(that)
              }
            }
          },
          {
            text: that.$t('common.cncl'),
            onClick: function () {
              return
            }
          }
        ]
      })
    }
  }
}
</script>
